import { getAuthenticatedRedirectTarget } from "~/utils/authRequestAsync";

export default defineNuxtRouteMiddleware(async (to, from) => {
  try {
    const auth = useAuthStore();
    if (!(await auth.renewAsync())) {
      throw Error("Renew failed");
    }
    // If no error is thrown but we're going to the login page redirect to the soruce page or to /admin/events
    if (to.fullPath.includes("login")) {
      const from = to.query["from"];
      const target = getAuthenticatedRedirectTarget(from);
      return navigateTo(target);
    }
  } catch (error) {
    // Error, we're not authenticated
    console.log("[AuthMiddleware] Error: " + error);
    if (!to.fullPath.includes("login")) {
      return navigateTo(`/admin/login?from=${to.fullPath}`, {
        redirectCode: 401,
        replace: true,
      });
    }
  }
});
